import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import BankAccountForm from '../../global/forms/bankAccountForm';
import ModalComponent from '../../ui/Modal';

import { updatePaymentMethod } from '../actions'
import { popError } from '../../global/actions';
import { PAGE_ROUTES } from '../../../constants/pageRoutes';

class RenterToOwnerComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitting: false,
      currentView: 'text'
    }

    this.onSubmit = this.onSubmit.bind(this);
    this.setCurrentView = this.setCurrentView.bind(this);
  }

  componentWillUnmount() {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'paymentmethod').length > 0) {
      this.props.dispatch(popError('paymentmethod'));
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.errors && this.props.errors.filter(e => e.errType === 'paymentmethod').length > 0) {
      this.setState({ isSubmitting: false });
    }
    if (prevProps.user && this.props.user
      && this.props.user.accounts.length > 0
      && (this.props.user.accounts.length !== prevProps.user.accounts.length
        || this.props.user.accounts[0].sourceId !== (prevProps.user.accounts[0] ? prevProps.user.accounts[0].sourceId : null))) {
      this.setState({ isSubmitting: false, currentView: 'success' });
    }
  }

  onSubmit(values) {
    let { dispatch } = this.props;
    setTimeout(() => this.setState({ isSubmitting: true }), 240);
    dispatch(updatePaymentMethod(values));
  }

  setCurrentView(view) {
    setTimeout(() => {
      this.setState({ currentView: view });
    }, 240)

  }
  //RENDER BODY
  renderTextBody() {
    return (<div>
      <div className="col-12">
        Becoming a CollegeWeekends.com owner and listing your property is easy! All we need is a valid bank account on file to get started.
      </div>
    </div>)
  }

  renderFormBody(error) {
    return (<div>
      <BankAccountForm
        onSubmit={this.onSubmit}
        onBack={() => { this.setCurrentView('text'); }}
        errorMessage={error}
        isModal={true} />
    </div>)
  }

  renderSuccessBody() {
    return (<div>
      <div className="col-12">
        Your account has been upgraded! <Link to="/dashboard/listing/forms/details">Create a listing</Link>!
      </div>
    </div>)
  }

  renderBody(currentView, error) {
    switch (currentView) {
      case 'text':
        return this.renderTextBody();
      case 'form':
        return this.renderFormBody(error);
      case 'success':
        return this.renderSuccessBody();
      default:
        return null;
    }
  }
  //RENDER BUTTONS
  renderTextButtonRow(onClose) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col">
          <label onClick={onClose} >Cancel</label>
        </div>
        <div className="col text-right">
          <a className='btn btn-primary' role='button' onClick={onClose}
            href={`/app/#${PAGE_ROUTES.OWNER_SIGN_UP_2}?successRedirect=${PAGE_ROUTES.CREATE_LISTING}`} >Continue</a>
        </div>
      </div>
    )
  }

  renderSuccessButtonRow(onClose) {
    return (
      <div className="w-100 row align-items-center m-0">
        <div className="col text-right pl-0">
          <button className='btn btn-primary' onClick={onClose} >Close</button>
        </div>
      </div>
    )
  }

  renderButtonRow(currentView, onClose, isSubmitting) {
    switch (currentView) {
      case 'text':
        return this.renderTextButtonRow(onClose);
      case 'success':
        return this.renderSuccessButtonRow(onClose);
      default:
        return null
    }
  }
  //MAIN RENDER
  render() {
    let { errors, onClose } = this.props;
    let { isSubmitting, currentView } = this.state;
    let title = "Ready to list your property?";
    if (currentView === 'form') { title = 'Add Bank Account' }
    if (currentView === 'success') { title = 'Success'; }
    let error = errors ? errors.filter(e => e.errType === 'paymentmethod')[0] : null;
    return (<ModalComponent
      id="RenterOwnerModal"
      title={title}
      body={this.renderBody(currentView, error)}
      footer={this.renderButtonRow(currentView, onClose, isSubmitting)}
      onClose={onClose} />
    );

  }
}

export default connect()(RenterToOwnerComponent);
